import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { navigationConfig } from '@shared/store';
import { NavigationConfig } from '@shared/models';
import { SELECT_QUESTIONNAIRE_STATE } from '@app/questionnaire';
import { map, takeUntil } from 'rxjs/operators';
import { CommonNavigationService } from 'src/app/shared/services';
import { GuardService } from '@app/core';
import { ActivatedRoute } from '@angular/router';
import { PageComponent } from 'src/app/shared/components/page/page.component';
import { LOAD_QUESTIONS } from '../store/questionnaire.actions';

/**
 * Home component from questionnaire
 */
@Component({
	selector: 'imv-home',
	templateUrl: './questionnaire.component.html',
	styleUrls: ['./questionnaire.component.scss'],
})
export class QuestionnaireComponent extends PageComponent implements OnInit, OnDestroy {
	
	/**
	 * RxJS operator to destroy all subscriptions after use
	 */
	private destroy$ = new Subject<void>();

	/**
	 * Constructor with _store param of type Store
	 *
	 * @param _store
	 * @param _navigationService
	 * @param _route
	 * @param _guardService
	 */
	constructor(
		_injector: Injector,
		private _store: Store,
		private _navigationService: CommonNavigationService,
		private _route: ActivatedRoute,
		private _guardService: GuardService,
	) {
		super(_injector)
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	/**
	 * Navigation configuration
	 */
	config!: NavigationConfig;

	/**
	 * Called to initialize a component and views, call initConfig() and enableBegin()
	 */
	ngOnInit(): void {
		this.initConfig();
		this.enableBegin();
		this._navigationService.setProgressBar(0);
		this._route.params.pipe(takeUntil(this.destroy$), map(params => +params['id'])).subscribe(() => {
			this._guardService.controlQuestionnaireNavigation();
		});
	}

	/**
	 * Load questions from questionnaire, set this.config by default
	 * and set config to navigationConfig
	 */
	private initConfig(): void {
		this._store.dispatch(LOAD_QUESTIONS());
		this.config = {
			isBegin: true,
			isNext: false,
			isPrevious: false,
			isDisabledNext: false,
			isDisabledBegin: true,
			isCancel: true,
		};
		this._store.dispatch(navigationConfig({ payload: this.config }));
	}

	/**
	 * Function to check if the response fron the service arrives to enable begin button
	 */
	private enableBegin(): void {
		this._store.select(<any>SELECT_QUESTIONNAIRE_STATE).pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
			if (response.questions.length > 0 && response.refusals.length > 0) {
				// Disabled the "start" button until the response from the service arrives.
				this.config = {
					...this.config,
					isDisabledBegin: false,
				};
				this._store.dispatch(navigationConfig({ payload: this.config }));
			}
		});
	}
}
